export const MileageName = {
  10000: 'Up to 10,000 miles',
  25000: 'Up to 25,000 miles',
  50000: 'Up to 50,000 miles',
  100000: 'Up to 100,000 miles',
  500000: 'Up to 500,000 miles',
};
